import { Box } from '@mui/material'
import clsx from 'clsx'

import style from './TabPanel.module.css'

interface TabPanelProps {
  children?: React.ReactNode
  index: number
  value: number
  disablePadding?: boolean
  className?: string
  scrollable?: boolean
}

const TabPanel = (props: TabPanelProps) => {
  const { children, value, index, disablePadding, className, scrollable, ...other } = props
  return (
    <div
      role="tabpanel"
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
      className={clsx(value === index ? style.tabContent : style.invisible, scrollable && style.scrollable, className)}
    >
      {value === index && (
        <Box
          sx={{
            p: props.disablePadding ? 0 : 4,
            flexGrow: 1,
            flexDirection: 'column',
            display: 'flex',
            alignItems: 'center',
            minHeight: 0,
            width: '100%',
          }}
        >
          {children}
        </Box>
      )}
    </div>
  )
}

export default TabPanel
